// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeController_inputRoot__3l_JA","arrowIcon":"DateRangeController_arrowIcon__1S0ln"};